export const radius = {
  sm: "8px", // inputs, small thumbnails, chips
  md: "16px", // cards, boxes, product images, buttons (dominant brand radius)
  card: "clamp(0.625rem, 0.3333rem + 1.2963vw, 1.5rem)", // every card / tile / grid image (product card, blog, social): 10 at 360 → 24 at 1440
  lg: "clamp(1.3125rem, 0.1667rem + 5.0926vw, 4.75rem)", // homepage boxes / section photos: XD 21 at 360 → 76 at 1440 (24.09 mock, literal)
  panel: "clamp(1.3125rem, 0.9792rem + 1.4815vw, 2.3125rem)", // title box of a loyalty-page section: 21 at 360 → 37 at 1440 (25.09 mock)
  pill: "999px", // fully-rounded badges / pill buttons
  circle: "50%", // avatars, circular icons
};

//${({ theme }) => theme.radius.???};
